export default __webpack_public_path__ + "static/media/tulflix_logo-icon.93cc8c92.png";